import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 fs-6 w-275px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-item px-3" }
const _hoisted_3 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_4 = { class: "symbol symbol-50px me-5" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = { class: "fw-bolder d-flex align-items-center fs-5" }
const _hoisted_8 = {
  href: "#",
  class: "fw-bold text-muted text-hover-primary fs-7"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_10 = { class: "menu-item px-5" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person text-primary me-4" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Tài khoản ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_14 = { class: "menu-item px-5" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-power text-danger me-4" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Thoát hệ thống ")
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            class: "xxxxx",
            src: 
              _ctx.AppService.renderImageUrl(_ctx.account_profile.avatar, '220', '200')
            ,
            alt: ""
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.account_profile.name), 1),
          _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.account_profile.email), 1)
        ])
      ])
    ]),
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_router_link, {
        to: "/profile",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _hoisted_11,
          _hoisted_12
        ]),
        _: 1
      })
    ]),
    _hoisted_13,
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.signOut())),
        class: "menu-link px-5"
      }, _hoisted_17)
    ])
  ]))
}